export const COOKIE_DOMAIN = () => process.env.NEXT_PUBLIC_SITE_COOKIE_DOMAIN;

export const GTM_KEY = () => process.env.NEXT_PUBLIC_GTM_KEY;

export const GTM_DEV_KEY = () => process.env.NEXT_PUBLIC_GTM_DEV_KEY;

export const IS_PRODUCTION = () =>
  process.env.NEXT_PUBLIC_APP_ENV === 'production';

export const IS_SECURE = () =>
  ['production', 'staging', 'review-app'].indexOf(
    process.env.NEXT_PUBLIC_APP_ENV ?? '',
  ) !== -1;
